import {inject} from "@angular/core";
import {HttpInterceptorFn} from "@angular/common/http";
import Keycloak from "keycloak-js";
import {defer} from "rxjs";
import {filter} from "rxjs/operators";

export const keycloakBearerInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(Keycloak);

  function addAuthHeader() {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${keycloak.token}`,
      },
    });
    return next(authReq);
  }

  if (keycloak?.authenticated && keycloak?.token) {
    if (keycloak.isTokenExpired()) {
      defer(() => keycloak.updateToken())
        .pipe(filter(refreshed => refreshed))
        .subscribe(() => addAuthHeader());
    } else {
      return addAuthHeader();
    }
  }

  return next(req);
};
